export const listQuickWords = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/quickword/standard/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listSuggestedQuickWords = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/quickword/suggested/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const listStandardQuickWordAutomations = async (
  sendAndWaitWs,
  quickWord
) => {
  const request = {
    quickWord,
  };
  const response = await sendAndWaitWs(
    "/quickword/standard/listRelatedAutomations",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
